var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgTransferi = function SvgTransferi(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#454B56",
    fillRule: "evenodd",
    d: "M16.971 17.033H5.26a.7.7 0 0 1 0-1.4h11.852l-3.209-3.111a.7.7 0 0 1 .975-1.005l4.378 4.246a.7.7 0 0 1 .114.861.7.7 0 0 1-.297.321l-4.336 4.205a.7.7 0 1 1-.974-1.005zM4.63 7.958a.7.7 0 0 1 .113-.862L9.121 2.85a.7.7 0 0 1 .975 1.006l-3.208 3.11H18.74a.7.7 0 0 1 0 1.4H7.028l3.209 3.112a.7.7 0 0 1-.975 1.005L4.926 8.278a.7.7 0 0 1-.296-.32",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgTransferi);
export default ForwardRef;